export default __webpack_public_path__ + "static/media/carbeauty-fill.46779689.svg";